import "core-js/es/map"
import "core-js/es/set"
import "react-app-polyfill/ie9"
import "react-app-polyfill/stable"
import React from "react"
import ReactDOM from "react-dom"
import "./assets/scss/main.scss"
import { Provider } from "react-redux"
import * as Sentry from "@sentry/browser"
import { BrowserRouter as Router } from "react-router-dom"
import { store } from "./store"
import * as serviceWorker from "./serviceWorker"
import Main from "./Main"
import "./polyfills/closest"
import "./polyfills/all-settled"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN
})

ReactDOM.render(
  <Provider store={store}>
    <Router basename="/">
      <Main />
    </Router>
  </Provider>,
  document.getElementById("root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
